export function capitalizeExceptPrepositionsAndLowerCase(stringValue, name) {
  const prepositions = ["in", "on", "at", "with", "by", "for", "to", "of", "from", "and", "as"];

  if (typeof stringValue !== "string" && name !== "basic_desc") {
    return stringValue;
  }
  if (typeof stringValue !== "string" && name !== "advance_desc") {
    return stringValue;
  }

  if (typeof stringValue === "string" && name === "basic_desc") {
    return stringValue;
  }
  if (typeof stringValue === "string" && name === "advance_desc") {
    return stringValue;
  }

  const words = stringValue.split(" ");
  const capitalizedWords = words.map((word) => {
    const hasOpeningBracket = word.includes("(");
    if (hasOpeningBracket) {
      const parts = word.split("(");
      const firstPart = parts[0];
      const secondPart = parts[1];
      const capitalizedSecondPart = secondPart.charAt(0).toUpperCase() + secondPart.slice(1);
      return firstPart + "(" + capitalizedSecondPart;
    }
    return prepositions.includes(word.toLowerCase())
      ? word.toLowerCase()
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  const resultString = capitalizedWords.join(" ");

  return resultString;
}
